import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLocalStorage } from "../utils/localStorage";
import { AUTH_NAVIGATE_OPTIONS, LOCAL_STORAGE } from "../utils/constants";
import { AuthService } from "../services/authService";
import { useSpinner } from "../components/spinner/SpinnerContext";

type ProtectedRouteProps = PropsWithChildren<{}>;

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const navigate = useNavigate();
  const { setShowSpinner } = useSpinner();
  useEffect(() => {
    const token = getLocalStorage(LOCAL_STORAGE.USER_TOKEN);
    if (!token) {
      navigate("/auth", { replace: true });
    } else {
      const loginStatus = getLocalStorage(LOCAL_STORAGE.PROFILE_STATUS);
      switch (loginStatus) {
        case AUTH_NAVIGATE_OPTIONS.NEW_USER:
        case AUTH_NAVIGATE_OPTIONS.ONBOARDING:
        case AUTH_NAVIGATE_OPTIONS.NEW_WEB_USER:
          AuthService.logout();
          setTimeout(() => {
            setShowSpinner(false);
            navigate("/auth");
          }, 300);
          break;
        default:
          break;
      }
    }
  }, [navigate]);

  return (
    <div className="layout-wrapper bg-center w-full  font-[PINYADA-SpaceGrotesk-Regular]">
      {children}
    </div>
  );
}
